import { createTheme } from 'smartstream-widgets/theme/GeniusSportsTheme'
import { ThemeOptions } from '@mui/material/styles'

const primaryColor = '#1565C0'
const secondaryColor = '#2196f3'
const successColor = '#7db82f'
const errorColor = '#ec4239'
const widgetBg = '#f0f3f7'

const  defaultTheme: ThemeOptions = {
   
  breakpoints: {
    values: {
      xs: 0,
      c420: 420,
      cs: 480,
      c576: 576,
      sm: 600,
      c728: 728,
      md: 960,
      lg: 1280,
      xl: 1920,
    }
  },
  palette: {
    primary: {
      main: primaryColor
    },
    secondary: {
      main: secondaryColor
    },
    success: {
      main: successColor
    },
    error: {
      main: errorColor
    },
    background: {
      widget: widgetBg      
    }
  },
  typography: {
    fontFamily: ['"Lato"', 'Arial', 'sans-serif'].join(','),
    button: {
      textTransform: 'unset'
    }
  },
  components: {
    MuiButton: {
      defaultProps: {
        disableRipple: true,
      },
    },
  }
  }

  export const getDefaultTheme = createTheme(defaultTheme)